<script>
import { mapGetters, mapActions } from 'vuex'

import Config from '@/config'

export default {
  name: 'RtxBanner',
  computed: {
    ...mapGetters('dcs', ['isFetching', 'dcsData']),
    isDcsEnabled() {
      return (
        !Config.isSandbox &&
        this.$abtProvider.isFeatureEnabled(
          'gate_perm_rtx_data_collection_enabled'
        )
      )
    },
    hasDcsData() {
      return !!this.dcsData?.caseDetails?.token && !this.isFetching
    },
  },
  created() {
    if (this.isDcsEnabled) {
      this.fetchDcs()
    }
  },
  methods: {
    ...mapActions('dcs', ['fetchDcs']),
    goToRtx() {
      window.location.href = `${window.origin}/v2/collection?t=${this.dcsData?.caseDetails?.token}`
    },
  },
}
</script>

<template>
  <div
    v-if="isDcsEnabled && hasDcsData"
    class="mb-4 global__notification global__notification--yellow cursor-pointer"
    @click="goToRtx"
  >
    <div class="global__notification-icon">
      <svg-icon icon-class="exclamation-yellow-filled" />
    </div>
    <div class="global__notification-content ">
      <div>
        <h3
          class="global__text-black"
          style="font-size: 16px; font-weight: 600; line-height: 24px; letter-spacing: -0.2px;"
        >
          {{ $t('rtx_banner_message') }}
        </h3>
        <p
          style="font-size: 14px; font-weight: 500; line-height: 20px; letter-spacing: -0.2px;"
        >
          {{ $t('rtx_banner_description') }}
        </p>
      </div>
      <el-button
        class="global__button-outline global__button-flex"
        @click="goToRtx"
      >
        {{ $t('rtx_banner_cta') }}
        <svg-icon icon-class="cta" />
      </el-button>
    </div>
  </div>
</template>
